import script from "./DistributionList.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributionList.vue?vue&type=script&setup=true&lang=js"

import "./DistributionList.vue?vue&type=style&index=0&id=ea9542b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea9542b2"]])

export default __exports__